import http from 'helpers/http';
import { getIOSNotch } from 'helpers/helpers';

const SAVE_HEIGHT = 'common/SAVE_HEIGHT';
const SHOW_ERROR = 'common/SHOW_ERROR';
const SAVE_MOBILELAYOUT = 'common/SAVE_MOBILELAYOUT';
const SET_SOUND = 'common/SET_SOUND';

export const initialState = {
  isSidebarShowing: false,
  settings: {},
  location: undefined,
  showError: false,
  marginLayout: 0,
  sound: true
};

export const checkMobileLayout =
  (isIOS, height) => async (dispatch, getState) => {
    let margin = 0;
    if (isIOS) {
      margin = getIOSNotch(height);
    }
    dispatch(saveMobileLayout(margin));
  };

export const logRequest = (params) => async (dispatch, getState) => {
  try {
    const result = await http.post('/logs', params);

    return result;
  } catch (err) {
    throw err;
  }
};


export const saveHeight = (height) => ({
  type: SAVE_HEIGHT,
  payload: {
    height
  }
});

export const setSound = () => ({
  type: SET_SOUND,
  payload: null
})

export const saveMobileLayout = (margin) => ({
  type: SAVE_MOBILELAYOUT,
  payload: {
    margin
  }
});

export const showError = (showError) => ({
  type: SHOW_ERROR,
  payload: {
    showError
  }
});

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_HEIGHT:
      return {
        ...state,
        webHeight: action.payload.height
      };
    case SHOW_ERROR:
      return {
        ...state,
        showError: action.payload.showError
      };
    case SAVE_MOBILELAYOUT:
      return {
        ...state,
        marginLayout: action.payload.margin
      };
    case SET_SOUND:
      return {
        ...state,
        sound: !state.sound
      }

    default:
      return state;
  }
};
